import { ReactNode } from "react"

export const AppSpace = () => {
    return (
        <div className='mt-5'>
        </div>
    )
}

interface EndBaseLineProps {
    children: ReactNode;
    top?: number;
}

export const EndBaseLine: React.FC<EndBaseLineProps> = ({ children, top }) => {
    return (
        <div className='flex justify-end items-end gap-2' style={{marginTop: top}}>
            {children}
        </div>
    );
};